// TODO werte fuer  den Paisy wert aus der excel hinzufuegen
export const PrivatVersichtert = [
  {
    'PAISY Wert': 'A',
    Bezeichnung: 'Allg. JAE',
  },
  {
    'PAISY Wert': 'B',
    Bezeichnung: 'Besond. JAE',
  },
  {
    'PAISY Wert': 'C',
    Bezeichnung: 2002,
  },
  {
    'PAISY Wert': 'N',
    Bezeichnung: 'KV befreit',
  },
  {
    'PAISY Wert': 'X',
    Bezeichnung: 'Beamte u. KV freie',
  },
  {
    'PAISY Wert': 'Z',
    Bezeichnung: '55. Lebensjahr',
  },
];
